import { isValidChartStyleRecid } from '@/composables/isValidChartStyleRecid';
import { initializeSampleChartStyleGroups } from '@/composables/initializeSampleChartStyleGroups';
import { refreshChartStyles } from '@/composables/refreshChartStyles';
import { getSavedChartStyleFromCache } from '@/composables/getSavedChartStyleFromCache';
import { getSampleChartStyleFromCache } from '@/composables/getSampleChartStyleFromCache';
import { SimpleFrontendChartStyle } from '@/interfaces/chartStyle';

export async function getChartStyle(recid: number | string, forceUpdate: boolean = false): Promise<SimpleFrontendChartStyle | null> {
  if (
    (typeof recid !== 'number' && typeof recid !== 'string') ||
    !isValidChartStyleRecid(recid, true)
  ) {
    return null;
  }

  const formattedRecid = Number(recid);
  const isSampleChartStyle = !isValidChartStyleRecid(formattedRecid, false);

  if (isSampleChartStyle) {
    let sampleChartStyle = getSampleChartStyleFromCache(formattedRecid);

    if (sampleChartStyle) {
      return sampleChartStyle;
    }

    await initializeSampleChartStyleGroups();

    sampleChartStyle = getSampleChartStyleFromCache(formattedRecid);

    if (!sampleChartStyle) {
      window.sc3WorkbenchLogger.error(`Failed to get sample ChartStyle with recid: ${formattedRecid}.`);
    }

    return sampleChartStyle;
  }

  if (!forceUpdate) {
    const cachedChartStyle = getSavedChartStyleFromCache(formattedRecid);

    if (cachedChartStyle) {
      return cachedChartStyle;
    }
  }

  await refreshChartStyles();

  const chartStyle = getSavedChartStyleFromCache(formattedRecid);

  if (!chartStyle) {
    window.sc3WorkbenchLogger.error(`Failed to get saved ChartStyle with recid: ${formattedRecid}.`);
  }

  return chartStyle;
}
